import { pdf } from '@react-pdf/renderer';

export const downloadPDF = async (document, fileName) => {
  try {
    const blob = await pdf(document).toBlob();
    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);
    
    // Create a link element
    const link = window.document.createElement('a');
    link.href = url;
    link.download = fileName;
    
    // Append to body, click, and remove
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
    
    // Clean up the URL
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
}; 